import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import useSmallScreenDetection from '../../uicomponents/useSmallScreenDetection.js'
import React, { useRef, useState, useEffect } from 'react'

const useStyles = makeStyles(theme => ({
  typography: {
    color: theme.palette.primary.contrastText,
    fontFamily: 'Roboto',
    fontWeight: 300
  }
}))

export default function TermAndConditions (props) {
  const classes = useStyles()
  const smallScreen = useSmallScreenDetection()
  return (
    <Typography
      className={classes.typography}
      variant={smallScreen ? 'body1' : 'h6'}
      component='p'
      align='justify'
    >
      MurAll is a decentralized, peer to peer protocol for user-created artwork.
      MurAll is free, public, open source software and a set of smart contracts
      written in Solidity that can be deployed to the Ethereum Blockchain,
      collectively known as (the “MurAll Protocol”). Before using the MurAll
      Protocol, please review the FAQs and documentation (the “Documentation”)
      for a detailed explanation on how the MurAll Protocol works.
      <br />
      <br />
      The MurAll Foundation (the “Foundation”, “we,” “us,” or “our”) is a
      not-for-profit entity. It does not own or lead MurAll, but rather supports
      and develops the free, open-source protocol that is MurAll. Portions of
      the MurAll Protocol are made available under the GNU General Public
      License v3 -- and the disclaimers contained therein apply including that
      the MurAll Protocol is provided “AS IS”, “WITH ALL FAULTS” and “AT YOUR
      OWN RISK”. We will not be liable for any liability or damages whatsoever
      associated with your use, inability to use, or your interaction with other
      users of, the MurAll Protocol, including any direct, indirect, incidental,
      special, exemplary, punitive or consequential damages, loss of profits,
      Ether (ETH) tokens, and any other cryptocurrencies or anything of value,
      including fiat currency.
      <br />
      <br />
      You acknowledge that the current version of the MurAll Protocol is a beta
      version and as such has not been fully-tested and may not perform as
      designed. On the MurAll Protocol, Ether (ETH) and Paint (PAINT), a
      cryptographic token, may be used for producing artwork on the MurAll
      Protocol. While you should always be thoughtful about the ETH or other
      tokens/cryptocurrencies you use (and can lose) through the MurAll
      Protocol, the concerns regarding loss of these tokens or cryptocurrencies
      is particularly acute with beta software that may not perform as designed,
      including that the beta version of the MurAll Protocol may not accurately
      reflect the intent of the smart contracts, the FAQs or the Documentation.
      Your use of the MurAll Protocol involves various risks, including, but not
      limited to losing tokens/cryptocurrencies due to invalidation. Careful due
      diligence should be undertaken as to the amount of ETH or PAINT you
      use/spend using the MurAll Protocol in beta format with full understanding
      that any transactions using these tokens/cryptocurrencies while drawing on
      MurAll Protocol could be subject to total loss. You assume any and all
      risk associated with your use of the MurAll Protocol.
      <br />
      <br />
      We have not sought to list PAINT on cryptocurrency exchanges, and it is
      not aware of any exchanges currently listing PAINT. In the future it may
      be listed or delisted on various possible exchanges and/or listed on
      others. We disavow any obligation with respect to the listing of PAINT on
      exchanges and it disavows any responsibility with respect to the value or
      trading of PAINT on exchanges. Persons trading PAINT or otherwise engaged
      in activities involving PAINT on exchanges assume any and all risk,
      including that of total loss, associated with such activities.
      <br />
      <br />
      You are solely responsible for compliance with all laws that may apply to
      your particular use of the MurAll Protocol. Cryptocurrencies and
      blockchain technologies have been the subject of scrutiny by various
      regulatory bodies around the world. We make no representation regarding
      the application of any laws, including but by no means limited to those
      relating to gaming, options, derivatives or securities, to your use of the
      MurAll Protocol. Indeed, depending on the jurisdiction and the
      contemplated use of the MurAll Protocol (whether yours or another’s), that
      use may be considered illegal. You agree that the We or any other referrer
      is not responsible for determining whether or which laws may apply to your
      use of the MurAll Protocol. You may modify the MurAll Protocol under the
      terms of the applicable open source license to effectuate your compliance
      with any applicable laws.
      <br />
      <br />
      The products and services, (collectively, the “Services”) provided by us
      may contain information, text, graphics, photos, or other materials
      (“Content”), including Content created or submitted to the Services by you
      or through use of the MurAll Protocol. We take no responsibility for and
      we do not expressly or implicitly endorse, support, or guarantee the
      completeness, truthfulness, accuracy, or reliability of any of the
      Content.
      <br />
      <br />
      By submitting Content to the MurAll Protocol, you represent and warrant
      that you have all rights, power, and authority necessary to grant the
      rights to Your Content contained within these Terms. Because you alone are
      responsible for Your Content, you may expose yourself to liability if you
      upload or share Content without all necessary rights.
      <br />
      <br />
      You retain any ownership rights you have in Your Content, but you grant us
      the following license to use that Content:
      <br />
      <br />
      By submitting, posting or displaying Content on or through the Services,
      you grant us a worldwide, royalty-free, perpetual, irrevocable,
      non-exclusive, transferable, and sublicensable license to use, copy,
      reproduce, process, adapt, modify, publish, transmit, display and
      distribute such Content in any and all media or distribution methods (now
      known or later developed). This license authorizes us to make your Content
      available to the rest of the world and to let others do the same. You
      agree that this license includes the right for us to provide, promote, and
      improve the Services and to make Content submitted to or through the
      Services available to other companies, organizations or individuals for
      the distribution, promotion or publication of such Content on other media
      and services. Such additional uses by us, or other companies,
      organizations or individuals, may be made with no compensation paid to you
      with respect to the Content that you submit, post, transmit or otherwise
      make available through the Services.
      <br />
      <br />
      All content displayed on the Services is created by users of the MurAll
      Protocol, and due to the decentralized nature of the MurAll Protocol, is
      not under our control, and thus may contain content that users deem
      explicit, profane, and/or offensive, and by using the Services you
      acknowledge this risk and accept sole responsibility for all that you see
      and interact with while using the Services. The Foundation makes no
      representations or warranties as to the quality, origin, or ownership of
      any content found in the Services, and all uses thereof, and the MurAll
      Protocol. We require all users to be 18 years old or older. You will
      immediately cease and not continue to access the site if you are under the
      age of 18.
      <br />
      IN NO EVENT AND UNDER NO THEORY OF LIABILITY, INCLUDING CONTRACT, TORT,
      NEGLIGENCE, STRICT LIABILITY, WARRANTY, OR OTHERWISE, WILL THE FOUNDATION
      BE LIABLE TO YOU FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL,
      SPECIAL, OR PUNITIVE DAMAGES, OR LOST PROFITS ARISING FROM OR RELATING TO
      THESE TERMS OR THE SERVICES, INCLUDING THOSE ARISING FROM OR RELATING TO
      CONTENT MADE AVAILABLE ON THE SERVICES THAT IS ALLEGED TO BE DEFAMATORY,
      OFFENSIVE, OR ILLEGAL. ACCESS TO, AND USE OF, THE SERVICES IS AT YOUR OWN
      DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ALL YOU SEE
      AND INTERACT WITH WHILE USING THE SERVICES.
      <br />
      <br />
      We shall not be liable for any errors, misrepresentations, or omissions
      in, of, and about, the content, nor for the availability of the content.
      We shall not be liable for any losses, injuries, or damages from the
      purchase, inability to purchase, display, or use of content.
      <br />
      <br />
    </Typography>
  )
}
